import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  clickTab(event) {
    document.getElementById("data-collection").querySelector(`[data-tab-id=${event.currentTarget.dataset.previewTabId}`).click();
  }
}
